import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// import './admindashboardcss.css';
import Header from './StaffDashboardHeader';
import Sidebar from './StaffDashboardSidebar';

function StaffDashboard() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  useEffect(() => {
    window.history.forward();
}, []);

  return (
    <div className='grid-container'>
      <Header OpenSidebar={OpenSidebar} />
      <Sidebar openSidebarToggle={openSidebarToggle} OpenSidebar={OpenSidebar} />
      <main className='main-container'>
        <Outlet /> 
      </main>
    </div>
  );
}

export default StaffDashboard;
